import { Helmet } from 'react-helmet-async';
import { Content } from './components/Content';
import { PageProvider } from './providers/PageProvider';

export const AdminJobDetailsPage = () => {
  return (
    <PageProvider>
      <Helmet>
        <title>Job Details - AutoScript Admin</title>
      </Helmet>
      <Content />
    </PageProvider>
  );
};
